/* SearchEmbedded.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _12 = "._1pbyjbo9{z-index:100000}";
const _11 = "._4t3i1osq{height:100%}";
const _10 = "._1bsb1osq{width:100%}";
const _9 = "._1ltvidpf{left:0}";
const _8 = "._154iidpf{top:0}";
const _7 = "._kqsw1n9t{position:fixed}";
const _6 = "._11q7vuon{background:var(--ds-surface,#fff)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SearchEmbeddedEnterKeyEvent, SearchEmbeddedSuggestionClickEvent, SearchEmbeddedViewEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import React, { useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { ANALYTICS_ACTION_SUBJECT_ID } from '../constants';
import { SearchDropdownEmbedded, SearchDropdownOverlay } from '../SearchDropdown';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _5 = "._kqswh2mm{position:relative}";
const _4 = "._4cvr1y6m{align-items:flex-start}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const SearchEmbeddedWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulp1b66 _1e0c1txw _2lx21bp4 _4cvr1y6m _kqswh2mm", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SearchEmbeddedWrapper.displayName = 'SearchEmbeddedWrapper';
}
const FullWidthSearchDropdown = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7, _8, _9, _10, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_11q7vuon _kqsw1n9t _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _1pbyjbo9", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FullWidthSearchDropdown.displayName = 'FullWidthSearchDropdown';
}
// eslint-disable-next-line max-lines-per-function
export const SearchEmbedded = _ref3 => {
  let {
    searchInputRef,
    additionalQueryParams = {},
    searchPlaceholder
  } = _ref3;
  const [searchOverlayVisible, setSearchOverlayVisible] = useState(false);
  const searchDropdownOverlayref = useRef(null);
  const backButtonRef = useRef(null);
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    enableMpacConfigurator
  } = useStatsig();
  const handleViewedAnalytics = _ref4 => {
    let {
      query,
      suggestionSource,
      count
    } = _ref4;
    fireAnalyticsEvent({
      eventType: SearchEmbeddedViewEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.SEARCH_EMBEDDED_VIEW,
      attributes: {
        query,
        suggestionSource,
        count
      }
    });
  };
  const handleSearchItemSelectionAnalytics = _ref5 => {
    let {
      query,
      position,
      popularity,
      suggestionSource,
      count
    } = _ref5;
    fireAnalyticsEvent({
      eventType: SearchEmbeddedSuggestionClickEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.SEARCH_EMBEDDED_ITEM_SELECTED,
      attributes: {
        query,
        position,
        popularity,
        suggestionSource,
        count
      }
    });
  };
  const handleEnterKeyPressAnalytics = _ref6 => {
    let {
      query,
      suggestionSource,
      count
    } = _ref6;
    fireAnalyticsEvent({
      eventType: SearchEmbeddedEnterKeyEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.SEARCH_EMBEDDED_ENTER_KEY_PRESSED,
      attributes: {
        query,
        position: -1,
        suggestionSource,
        count
      }
    });
  };
  const onBlur = e => {
    if (searchDropdownOverlayref.current && !searchDropdownOverlayref.current.contains(e.relatedTarget) && backButtonRef.current) {
      backButtonRef.current.focus();
    }
  };
  const searchInput = /*#__PURE__*/_jsx(SearchDropdownOverlay, {
    onViewed: handleViewedAnalytics,
    closeOverlay: () => {
      setSearchOverlayVisible(false);
    },
    onSuggestionSelection: handleSearchItemSelectionAnalytics,
    onEnterKeyPress: handleEnterKeyPressAnalytics,
    backButtonRef: backButtonRef,
    additionalQueryParams: additionalQueryParams
  });
  if (searchOverlayVisible) {
    return enableMpacConfigurator() ? (/*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/_jsx(FullWidthSearchDropdown, {
      ref: searchDropdownOverlayref,
      onBlur: onBlur,
      children: searchInput
    }), document.body)) : /*#__PURE__*/_jsx(FullWidthSearchDropdown, {
      ref: searchDropdownOverlayref,
      onBlur: onBlur,
      children: searchInput
    });
  }
  return /*#__PURE__*/_jsx(SearchEmbeddedWrapper, {
    children: /*#__PURE__*/_jsx(SearchDropdownEmbedded, {
      onViewed: handleViewedAnalytics,
      onSuggestionSelection: handleSearchItemSelectionAnalytics,
      onEnterKeyPress: handleEnterKeyPressAnalytics,
      searchInputRef: searchInputRef,
      onInputFocus: () => {
        setSearchOverlayVisible(true);
      },
      searchPlaceholder: searchPlaceholder,
      additionalQueryParams: additionalQueryParams
    })
  });
};